var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 1.5C6.95507 1.5 5.5 2.95507 5.5 4.75C5.5 6.54493 6.95507 8 8.75 8C10.5449 8 12 6.54493 12 4.75C12 2.95507 10.5449 1.5 8.75 1.5ZM4 4.75C4 2.12665 6.12665 0 8.75 0C11.3734 0 13.5 2.12665 13.5 4.75C13.5 7.37335 11.3734 9.5 8.75 9.5C6.12665 9.5 4 7.37335 4 4.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67712 12.622C4.30591 11.4808 6.49231 11 8.81 11C11.1277 11 13.3163 11.4808 14.9474 12.6217C16.6158 13.7887 17.63 15.5999 17.63 18.06V20.6C17.63 21.0142 17.2942 21.35 16.88 21.35H0.75C0.335786 21.35 0 21.0142 0 20.6V18.06C0 15.6007 1.01099 13.7895 2.67712 12.622ZM3.53788 13.8505C2.28901 14.7255 1.5 16.0693 1.5 18.06V19.85H16.13V18.06C16.13 16.0701 15.3392 14.7263 14.0876 13.8508C12.7987 12.9492 10.9523 12.5 8.81 12.5C6.66769 12.5 4.82409 12.9492 3.53788 13.8505Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.81614ff6c14a348daa451edd0ba2f77d.svg";
export { ForwardRef as ReactComponent };